import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function BackLink({ to, label = 'Back', className = '' }) {
  const navigate = useNavigate();
  const cls = `inline-flex items-center gap-2 text-text-muted hover:text-champagne transition-colors text-sm ${className}`;
  if (to) {
    return (
      <Link to={to} className={cls}>
        <ArrowLeft className="w-4 h-4" /> {label}
      </Link>
    );
  }
  return (
    <button type="button" onClick={() => navigate(-1)} className={cls}>
      <ArrowLeft className="w-4 h-4" /> {label}
    </button>
  );
}
